import { SWRConfig } from 'swr';
import { API } from './axios';

const fetcher = (url) => API.get(url).then(res => res.data);
const ConfigSWR = (props) => {
  const {children} = props;

  return(
    <SWRConfig
    value={{
      fetcher: fetcher,
      // Reduce console spam when the browser blocks requests (SSL/cert/network).
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    }}
    >
      {children}
    </SWRConfig>
  )
}

export default ConfigSWR;